import styled from 'styled-components';
import { CmsImage } from '@thisisdevelopment/heritage-core-library';
import theme from 'theme';

export const Banner = styled(CmsImage)`
  @media ${theme.mediaQuery.tablet} {
    display: none;
  }

  width: 100%;
  height: 400px;
  object-fit: cover;
`;
